import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchEventArpLog, fetchEventLog } from '../api/eventLogApi';

/**
 * Default date range mirrors the Blazor `EventLog.razor.cs` view-model:
 *   StartDate = DateTime.Now.AddDays(-10);
 *   EndDate   = DateTime.Now.AddDays(+10);
 */
function useDefaultDateRange() {
  return useMemo(() => {
    const now = new Date();
    const start = new Date(now);
    start.setDate(now.getDate() - 10);
    const end = new Date(now);
    end.setDate(now.getDate() + 10);
    return { startDate: start, endDate: end };
  }, []);
}

export function useEventLog(searchEvents: string) {
  const { startDate, endDate } = useDefaultDateRange();
  return useQuery({
    queryKey: [
      'event-log',
      { searchEvents, startDate: startDate.toISOString(), endDate: endDate.toISOString() },
    ],
    queryFn: () => fetchEventLog({ searchEvents, startDate, endDate }),
  });
}

export function useEventArpLog(eventCode: string | null) {
  return useQuery({
    queryKey: ['event-arp-log', eventCode],
    queryFn: () => fetchEventArpLog(eventCode!),
    enabled: !!eventCode,
  });
}
